import * as React from 'react';
import { Row } from 'reactstrap';
import { WrappedInput } from '../../../../share/components/Input/Input';
import { IProvider } from '../../../../share/types/provider';
import SearchImageDropZone from './SearchImageDropZone';

export interface ISearchImageFormProps {
  setValue: (path: string, value: any) => void;
  searchInfo: any;
  loading: boolean;
  providers: IProvider[];
  imageUploadingStatus: {},
  imageSelected: boolean;
  imageName: string;
  onClearSearch: () => void;
}

export class SearchImageForm extends React.Component<ISearchImageFormProps, any> {
  constructor(props: ISearchImageFormProps) {
    super(props);
  }

  public getProvidersOptions(providers: IProvider[]) {
    if (!providers || providers.length === 0) {
      return false;
    } else {
      return providers.map((provider) => {
        return <option key={provider.providerId} value={provider.providerId}>{provider.name}</option>
      })
    }
  }

  public render() {
    return (
      <>
        <Row>
          <div className="col-md-12 formSize">
            <SearchImageDropZone
              setValue={this.props.setValue}
              imageName={this.props.imageName}
              imageSelected={this.props.imageSelected}
              onClearSearch={this.props.onClearSearch}
              imageUploadingStatus={this.props.imageUploadingStatus}
              searchInfo={this.props.searchInfo}
              loading={this.props.loading}
            />
            <WrappedInput
              type="select"
              className="providers-dropdown subFont"
              {...this.form('provider')}
              id="selectProvider"
              md={12}
              disabled={this.props.loading}
              value={this.props.searchInfo.provider}
              onChange={event => {
                this.props.setValue('searchInfo.provider', event.target.value);
              }}
            >
              <option value="">Select a provider</option>
              {this.getProvidersOptions(this.props.providers)}
            </WrappedInput>
          </div>
        </Row>
      </>
    );
  }

  public form = (key: string) => {
    const { searchInfo, loading } = this.props;

    return {
      id: key,
      name: key,
      md: 12,
      value: searchInfo[key],
      onChange: (e: any) => this.props.setValue(`searchInfo.${key}`, e.target.value),
      required: true,
      disabled: loading
    }
  }
}

export default SearchImageForm;
